import { TranslateService } from '@ngx-translate/core';
import {AfterViewInit, Component, OnInit} from '@angular/core';
import {DataGridColumnType, DataGridSettingModel} from "../../models/data-grid.model";
import {UserEnum} from "../../enums/user.enum";
import {ProfileService} from "../../services/profile.service";


@Component({
  selector: 'app-users-page',
  templateUrl: './users-page.component.html',
  styleUrls: ['./users-page.component.scss']
})
export class UsersPageComponent implements OnInit {

  dataGridSettings!: DataGridSettingModel;
  isEmployee: boolean = false;

  constructor(private profileService: ProfileService,
    public translateService: TranslateService) {
  }

public translate( key: string){
  return this.translateService.instant(key)
}

  ngOnInit(): void {
    this.InitiateGrid();
  }

  ngAfterViewInit() : void {
    this.translateService.get('userstag').subscribe((translated_key1: string) => {
      this.translateService.get('employeestag').subscribe((translated_key2: string) => {      
        this.dataGridSettings.tabs = [{name: translated_key1, value: 1, booleanValue: false}, {name: translated_key2, value: 2, booleanValue: true}];
      });
    });
  }

  InitiateGrid() {
    this.dataGridSettings = {
      dataService: this.profileService,
      getAllServiceName: 'retrieveAllUsers',
      hasBooleanParam: true,
      hasTabs: true,
      tabs: [{name: this.translateService.instant('userstag'), value: 1, booleanValue: false}, {name: this.translateService.instant('employeestag'), value: 2, booleanValue: true}],
      selectedTab: 1,
      columns: [
        {
          DbName: UserEnum.name,
          Name: 'name',
          LocalizationKey: 'WWW.Name',
          Type: DataGridColumnType.String
        },
        {
          DbName: UserEnum.surname,
          Name: 'surname',
          LocalizationKey: 'WWW.Name',
          Type: DataGridColumnType.Number,
        },
        {
          DbName: UserEnum.email,
          Name: 'email',
          LocalizationKey: 'WWW.Name',
          Type: DataGridColumnType.String,
        },
        {
          DbName: UserEnum.phoneNumber,
          Name: 'phone',
          LocalizationKey: 'WWW.Name',
          Type: DataGridColumnType.String,
        },
        {
          DbName: UserEnum.active,
          Name: 'status',
          LocalizationKey: 'WWW.Name',
          Type: DataGridColumnType.Bool,
        },
        {
          DbName: 'CUSTOM_2',
          Name: 'change',
          LocalizationKey: 'WWW.Edit',
          Type: DataGridColumnType.Edit,
          Width: '100px',
          TextAlign: 'center'
        },
        {
          DbName: 'CUSTOM_3',
          Name: 'changePassword',
          LocalizationKey: 'WWW.ChangePassword',
          Type: DataGridColumnType.ChangePassword,
          Width: '100px',
          TextAlign: 'center'
        },
      ],
      sorting: true,
      isDataPaged: true,
      defaultPageSize: '5',
      sortBy: '',
      enableSearch: false,
      hasGlobalSearchBar: true,
      enableRefresh: true,
      searchTitle: 'Search users',
      searchColumns: ['SearchParam'],
      dataGridName: 'users-title',
      searchColumnName: 'Search',
      editUrl: '/dashboard/users/edit',
      addUrl: '/dashboard/users/add',
      editComponent: 'UserEditComponent',
      addComponent: 'UserAddComponent',
      changePasswordComponent: 'ChangePasswordFromAdminComponent',
      addButtonName: 'add-user'
    }
  }
}
